/**
 * Returns a new object containing only the specified keys of the input object.
 *
 * Similar to `Pick` TypeScript utility type, except it works on values instead of types.
 */
export function valuePick<TRecord extends object, TKeys extends readonly (keyof TRecord)[]>(
    record: TRecord,
    keys: TKeys,
): Pick<TRecord, TKeys[number]> {
    const pickedEntries = keys.map((key) => [key, record[key]] as const);

    return Object.fromEntries(pickedEntries) as Pick<TRecord, TKeys[number]>;
}
